// @ts-ignore
import * as L from 'leaflet/dist/leaflet-src.esm.js';
import { addSwitchScale } from './switchScaleControl';
export class ScaleControl {
    constructor() {
        this.object = null;
        this.object = null;
        addSwitchScale();
    }
    /**
     * This function creates a scale control and returns it.
     * @param {string} [position=topright] - string = 'bottomleft'
     * @returns the scaleControl object.
     */
    createScaleControl() {
        const scaleControl = new L.Control.SwitchScaleControl({
            updateWhenIdle: true,
            recalcOnPositionChange: true,
            recalcOnZoomChange: true,
        });
        this.object = scaleControl;
        return scaleControl;
    }
    /**
     * If the object exist, remove it.
     * @returns The object is being returned.
     */
    removeScaleControl() {
        if (!this.object)
            return;
        this.object.remove();
        this.object = null;
    }
}
//# sourceMappingURL=scaleControl.js.map